/* 鉴权管理 */
import request from '@/utils/request'

export default {
	/* 登录 */
	loginAPI(params) {
		return request({
			url: '/user/login',
			method: 'post',
			data: params,
		})
	},
	tokenLoginAPI(params) {
		return request({
			url: '/user/get_user_by_token',
			method: 'get',
			data: params,
		})
	},
	/* 登出 */
	logoutAPI(params) {
		return request({
			url: '/user/logout',
			method: 'post',
			data: params,
		})
	},
	/* 发送重置密码邮件 */
	sendResetPasswordEmail(params) {
		return request({
			url: '/user/send_reset_password_email',
			method: 'post',
			data: params,
		})
	},
	/* 通过邮件方式重置密码  */
	resetPasswordByEmailAPI(params) {
		return request({
			url: '/user/reset_password_by_email',
			method: 'post',
			data: params,
		})
	},
	/* 判断用户名是否被注册 */
	accountHasRegisterAPI(params) {
		return request({
			url: '/user/has_register',
			method: 'get',
			data: params,
		})
	},
	/* 注册账号 */
	accountRegisterAPI(params) {
		return request({
			url: '/user/register',
			method: 'post',
			data: params,
		})
	},
	/* 判断用户名是否被注册 */
	accountHasMobileAPI(params) {
		return request({
			url: '/Validate/checkMobile',
			method: 'POST',
			data: params,
		})
	},
	//发验证码
	sendVerificationCodeApi(params) {
		return request({
			url: '/Validate/getVerificationCode',
			method: 'POST',
			data: params,
		})
	},
	
}
